export default { sha: '0578a1bc3fdb32a4af7d25c848cb36c757d75e42', buildNumber: 'undefined' }
